export enum EntryEnum {
  NewPack = 'newpack',
  NewBan = 'newban',
  ExistPack = 'existpack',
  ExistBan = 'existban',
  Cpo = 'cpo',
  Relocation = 'relocation',
  WsFilter = 'wsfilter',
  WifiKids = 'wifikids',
  IspBzkPass = 'ispbzkpass',
  Vas = 'vas',

  Elct = 'elct',
}
